import request from '@/utils/request'

// 查询历史案例列表
export function listHistoricalcases(query) {
  return request({
    url: '/screen/creditlibrary/historicalcases/list',
    method: 'get',
    params: query
  })
}

// 查询历史案例详细
export function getHistoricalcases(pid) {
  return request({
    url: '/screen/creditlibrary/historicalcases/detail/' + pid,
    method: 'get'
  })
}

// 新增历史案例
export function addHistoricalcases(data) {
  return request({
    url: '/screen/creditlibrary/historicalcases/add',
    method: 'post',
    data: data
  })
}

// 修改历史案例
export function updateHistoricalcases(data) {
  return request({
    url: '/screen/creditlibrary/historicalcases/edit',
    method: 'post',
    data: data
  })
}

// 删除历史案例
export function delHistoricalcases(pid) {
  return request({
    url: '/screen/creditlibrary/historicalcases/delete/' + pid,
    method: 'get'
  })
}
